<template>
  <div>
    <label :for="idInner" v-if="libelleLong">
      <div v-html="libelleLong" class="mb-2"></div>
    </label>

    <template v-if="modeAffichageCaseACocher === 'CHECKBOX'">
      <v-checkbox
        :style="{ width: largeurMaxEnPx }"
        :input-value="value"
        :true-value="true"
        :false-value="false"
        @change="handleChange"
        :rules="caseRules"
        v-bind="$attrs"
      >
        <template v-slot:label>
          <div class="d-flex">
            <span v-html="label"></span>
            <span class="ml-1 red--text" v-if="!optionel">*</span>
          </div>
        </template>
      </v-checkbox>
    </template>

    <template v-if="modeAffichageCaseACocher === 'SWITCH'">
      <v-switch
        :style="{ width: largeurMaxEnPx }"
        :input-value="value"
        :true-value="true"
        :false-value="false"
        @change="handleChange"
        :rules="caseRules"
        v-bind="$attrs"
      >
        <template v-slot:label>
          <div class="d-flex">
            <span v-html="label"></span>
            <span class="ml-1 red--text" v-if="!optionel">*</span>
          </div>
        </template>
      </v-switch>
    </template>
    <infobulle v-if="descriptionPopup" :descriptionPopup="descriptionPopup"> </infobulle>
  </div>
</template>
   

<script>
import ChampBase from "@/components/ui/mixins/ChampBase"
export default {
  mixins: [ChampBase],
  computed: {
    modeAffichageCaseACocher() {
      return this.champ?.modeAffichageCaseACocher ?? "CHECKBOX"
    },
    caseRules() {
      return [(v) => this.optionel || !!v || this.champObligatoireMessage]
    }
  },

  methods: {
    handleChange(event) {
      this.$emit("input", event)
    },
    setValue(value) {
      this.handleChange(value)
    }
  }
}
</script>

<style>
</style>